import { EmptyState } from '@shopify/polaris';

export interface PushEmptyStateProps {
  onGotoCompose?: () => void;
}

export function HistoryEmptyState({ onGotoCompose }: PushEmptyStateProps) {
  return (
    <EmptyState
      heading="مفيش notifications مبعوته لسه"
      action={onGotoCompose ? { content: 'ابعت أول notification', onAction: onGotoCompose } : undefined}
      image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
    >
      <p>أول ما تبعت notification، هتلاقي هنا كل الإحصائيات: الوصول، الفتح، الضغط، والـ conversions.</p>
    </EmptyState>
  );
}

export function SchedulesEmptyState({ onGotoCompose }: PushEmptyStateProps) {
  return (
    <EmptyState
      heading="مفيش schedules لسه"
      action={onGotoCompose ? { content: 'اعمل أول schedule', onAction: onGotoCompose } : undefined}
      image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
    >
      <p>تقدر تجدول إشعار لمرة واحدة، أو لـ schedule متكرر (cron)، أو يطلق حسب حدث (signup / cart idle).</p>
    </EmptyState>
  );
}

export function TemplatesEmptyState({ onGotoCompose }: PushEmptyStateProps) {
  return (
    <EmptyState
      heading="مفيش templates لسه"
      action={onGotoCompose ? { content: 'اعمل أول template', onAction: onGotoCompose } : undefined}
      image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
    >
      <p>الـ Templates بتخلّيك تحفظ صياغات إشعارات بتستخدمها كتير وتعيد تحميلها بضغطة زرار.</p>
    </EmptyState>
  );
}
